import { render, staticRenderFns } from "./RouterViewLayer.vue?vue&type=template&id=296fdd68"
import script from "./RouterViewLayer.vue?vue&type=script&lang=js"
export * from "./RouterViewLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports